import fields from "./fields.utils";


const schema_special = {
    ...fields.notes,
    //source
    "source_uuid": {
        type: 'select',
        label: 'source',
        value: '',
        options: [],
        required: true
    },
    "address1": {
        label: "Address Line 1",
        placeholder: "Address Line 1",
        value: '',
        type: "text",
        required: true,


    },
    "address2": {
        label: "Address Line 2",
        placeholder: "Address Line 2",
        value: '',
        type: "text",

    },
    "address3": {
        label: "Address Line 3",
        placeholder: "Address Line 3",
        type: "text",
        value: '',

    },
    "address4": {
        label: "Address Line 4",
        placeholder: "Address Line 4",
        type: "text",
        value: '',

    },
    "city": {
        label: "City",
        placeholder: "City",
        type: "text",
        value: '',
        required: true,

    },
    "postcode": {
        label: 'Postal Code',
        placeholder: 'Postal Code',
        type: "address-lookup",
        value: '',
        required: true,

    },
    "first_name": {
        label: "First Name",
        placeholder: "First Name",
        type: "text",
        value: '',
        required: true,

    },
    "last_name": {
        label: "Last Name",
        placeholder: "Last Name",
        type: "text",
        value: '',
        required: true,

    },
    "date_of_birth": {
        label: 'Date of birth',
        type: 'date-mask',
        value: '',
        required: true,

        placeholder: 'Date of Birth'
    },
    "number_of_drivers": {
        label: "number of drivers",
        type: 'number',
        value: 0,
        required: true,
        placeholder: 'number of drivers'
    },
    "dob_youngest_driver": {
        label: 'Date of birth for the Youngest driver',
        type: 'date-mask',
        value: '',
        placeholder: 'Date of Birth Youngest Driver'
    },
    "dob_oldest_driver": {
        label: 'Date of birth for the Oldest driver',
        type: 'date-mask',
        value: '',
        placeholder: 'Date of Birth Oldest Driver'
    },
    //vehicle
    "vehicle_type": {
        type: 'select',
        label: 'vehicle type',
        value: '',
        options: [],
        required: true,
    },
    "email": {
        label: 'Email Address',
        placeholder: 'Email Address',
        type: 'email',
        value: '',
    },
    "telephone": {
        label: "Telephone",
        placeholder: "Telephone",
        type: "text",
        value: '',
        required: true,
    },
    ...fields.marketing,
    ...fields.title,
    ...fields.cross_selling
};
export default schema_special;
